module.exports = __webpack_public_path__ + "img/ikon_tumlare.4f4c3121.svg";